import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import LinkButton from 'flarum/common/components/LinkButton';
import IndexPage from 'flarum/forum/components/IndexPage';
import Navigation from 'flarum/common/components/Navigation';
import ItemList from 'flarum/common/utils/ItemList';
import BadgeManager, { BadgeCounts } from './BadgeManager';
import UnreadBadge from './components/UnreadBadge';
// 使用 compat 方式获取 TagLinkButton，避免类型报错
// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const flarum: any;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const TagLinkButton: any = flarum.core.compat['tags/components/TagLinkButton'];

export default function addNavigationBadges() {
  // 存储Badge计数的全局状态
  let badgeCounts: BadgeCounts = { all: 0, featured: 0, following: 0, tags: {} };

  // 初始化Badge计数
  const initBadgeCounts = () => {
    if (app.session.user) {
      BadgeManager.getCounts().then((counts) => {
        badgeCounts = counts;
        m.redraw();
      });
    }
  };

  // 监听Badge计数更新
  BadgeManager.onUpdate((counts: BadgeCounts) => {
    badgeCounts = counts;
    m.redraw();
  });

  // 页面初始化时获取Badge计数
  extend(IndexPage.prototype, 'oncreate', function () {
    initBadgeCounts();
  });

  // 用户登录/退出时重新初始化
  extend(IndexPage.prototype, 'oninit', function () {
    initBadgeCounts();
  });

  // 动态添加Badge的辅助函数
  const addBadgeToItem = (item: any, count: number): any => {
    if (!count || count <= 0) {
      return item;
    }

    // 如果item是JSX元素，克隆并添加Badge
    if (item && typeof item === 'object' && 'children' in item) {
      return {
        ...item,
        children: [
          item.children,
          <UnreadBadge count={count} />
        ]
      };
    }

    return item;
  };

  // 扩展navItems来添加Badge
  extend(IndexPage.prototype, 'navItems', function (items: ItemList<any>) {
    if (!app.session.user || !badgeCounts) return;

    // All Discussions Badge
    const allItem = items.get('allDiscussions');
    if (allItem && badgeCounts.all > 0) {
      items.replace('allDiscussions', addBadgeToItem(allItem, badgeCounts.all));
    }

    // Featured Badge
    const featuredItem = items.get('featured');
    if (featuredItem && badgeCounts.featured > 0) {
      items.replace('featured', addBadgeToItem(featuredItem, badgeCounts.featured));
    }

    // Following Badge
    const followingItem = items.get('following');
    if (followingItem && badgeCounts.following > 0) {
      items.replace('following', addBadgeToItem(followingItem, badgeCounts.following));
    }
  });

  // 直接在 TagLinkButton 的 view 输出中注入角标，确保出现在链接内部
  extend(TagLinkButton.prototype, 'view', function (vdom: any) {
    // 仅在用户已登录且有计数数据时显示
    if (!app.session.user || !badgeCounts) return;

    const tag = this.attrs?.model;
    if (!tag || typeof tag.id !== 'function') return;

    const tagId = String(tag.id());
    const count = badgeCounts.tags?.[tagId] || 0;
    if (!count || count <= 0) return;

    // 统一 children 为数组，追加未读角标
    const children = Array.isArray(vdom.children)
      ? vdom.children.slice()
      : (vdom.children != null ? [vdom.children] : []);

    children.push(<UnreadBadge count={count} />);
    vdom.children = children;
  });

  // 监听路由变化，在页面切换后刷新Badge
  let currentRoute = app.current.get('routeName');
  extend(IndexPage.prototype, 'onupdate', function () {
    const newRoute = app.current.get('routeName');
    if (newRoute !== currentRoute) {
      currentRoute = newRoute;
      if (app.session.user) {
        setTimeout(() => {
          BadgeManager.refresh();
        }, 200); // 给页面时间渲染
      }
    }
  });

}
